import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = (theme: ComposedTheme) => ({
  root: {},
  pinSection: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      fill: theme.palette.text.dark,
    },
    '& p': {
      margin: 0,
      marginLeft: theme.spacing.unit,
      fontSize: 14,
      color: theme.palette.text.dark,
      fontFamily: theme.typography.fontFamily,
    },
    paddingBottom: 10,
    borderBottom: `1px solid ${theme.palette.accent}`,
  },
  pinButtons: {
    marginLeft: theme.spacing.unit * 2,
  },
  clearButton: {
    marginLeft: 18,
  },
  filterWrapper: {
    padding: [5, 0, 0],
  },
  filterLabel: {
    lineHeight: '30px',
    fontSize: 14,
    fontWeight: theme.typography.fontWeightHeavy,
    color: theme.palette.text.midGray,
    fontFamily: theme.typography.label.fontFamily,
    margin: 0,
  },
  pinBold: {
    fontWeight: theme.typography.fontWeightHeavy,
  },
  pinHidden: {
    display: 'none',
  },
  pinLast: {
    marginLeft: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
    borderLeft: `1px solid ${theme.palette.accent}`,
  },
  pinSectionNoBorder: {
    border: 'none',
  },
});

export default createUseStyles(styles);
